import { Alert, AlertTitle, Collapse, Stack, Typography } from "@mui/material";

interface MessageGroup {
  id: string;
  name?: string;
  messages: string[];
}

interface Props {
  title?: string;
  severity?: "error" | "warning";
  groups: MessageGroup[];
  showGroupNames?: boolean;
  hint?: string;
}

const ActionChecksAlert = ({ title, severity = "error", groups, showGroupNames, hint }: Props) => (
  <Collapse appear in sx={{ width: "100%" }}>
    <Alert severity={severity} sx={{ textAlign: "left" }}>
      {title && <AlertTitle>{title}</AlertTitle>}
      <Stack spacing={1}>
        {groups.map(({ id, name, messages }) => (
          <Stack key={id} spacing={0.5}>
            {showGroupNames && (
              <Typography variant="inherit">
                <strong>{name}</strong>
              </Typography>
            )}
            {messages.map((message) => (
              <Typography key={message} variant="inherit">
                {message}
              </Typography>
            ))}
          </Stack>
        ))}
        {hint !== undefined && <Typography variant="inherit">{hint}</Typography>}
      </Stack>
    </Alert>
  </Collapse>
);

export default ActionChecksAlert;
